<div class="button-wrapper">
  <div class="return-wrapper">
    <a [routerLink]="['../']" class="return"><i id="icon-chevron" class="fas fa-chevron-left"></i> {{'BACK' | translate}}</a>
  </div>
</div>

<article class="form-wrapper">
  <header class="form-header">{{"NEW_COACH" | translate}}</header>
  <form class="new-client-form" [formGroup]="signupForm" (ngSubmit)="onSubmit()">
    <ul class="warning-list" *ngIf="emailErrorMessages.length !== 0">
      <li *ngFor="let m of emailErrorMessages" class="warning-item">{{ m }}</li>
    </ul>

    <label for="email">{{ 'EMAIL' | translate }}</label>
    <input id="email" type="email" class="email" formControlName="email" [placeholder]="'EMAIL' | translate" />
    <p *ngIf="signupForm.get('email')!.invalid && invalidSubmission" class="warning">{{'ENTER_AN_EMAIL_ADDRESS' | translate}}</p>
    <ul class="warning-list" *ngIf="emailErrorMessages.length !== 0">
      <li *ngFor="let m of emailErrorMessages" class="warning-item">{{ m }}</li>
    </ul>

    <div class="name-wrapper">
      <div class="first-name-wrapper">
        <label for="first-name">{{ 'FIRST_NAME' | translate }}</label>
        <input id="first-name" type="text" class="first-name" formControlName="firstName" [placeholder]="'FIRST_NAME' | translate" />
        <p *ngIf="signupForm.get('firstName')!.invalid && invalidSubmission" class="warning">{{'ENTER_A_FIRST_NAME' | translate}}</p>
        <ul class="warning-list" *ngIf="firstNameErrorMessages.length !== 0">
          <li *ngFor="let m of firstNameErrorMessages" class="warning-item">{{ m }}</li>
        </ul>
      </div>
      <div class="last-name-wrapper">
        <label for="last-name">{{ 'LAST_NAME' | translate }}</label>
        <input id="last-name" type="text" class="last-name" formControlName="lastName" [placeholder]="'LAST_NAME' | translate" />
        <p *ngIf="signupForm.get('lastName')!.invalid && invalidSubmission" class="warning">{{'ENTER_A_LAST_NAME' | translate}}</p>
        <ul class="warning-list" *ngIf="lastNameErrorMessages.length !== 0">
          <li *ngFor="let m of lastNameErrorMessages" class="warning-item">{{ m }}</li>
        </ul>
      </div>
    </div>

    <label for="language">{{ 'LANGUAGE' | translate }}</label>
    <select id="language" formControlName="language">
      <option [ngValue]="null" disabled>{{ 'SELECT_A_LANGUAGE' | translate }}</option>
      <option [ngValue]="language" *ngFor="let language of languages; first as firstElement">{{ language | translate}}</option>
    </select>

    <button class="submit">{{'SIGNUP' | translate}}</button>
  </form>
</article>
